import PropTypes from 'prop-types';
import * as React from 'react';

import stylesAutoLayout from '../AutoLayout.less';
import SavableComponentContainer from '../SavableComponentContainer';
import {ContentComponent} from 'src/js/model/auto_layout_content_schema';
import {LayoutComponent} from 'src/js/model/auto_layout_layout_schema';
import {MetadataSchema} from 'src/js/model/auto_layout_metadata_schema';

const SingleScreenWrapper = ({
  autoLayoutStateId,
  config,
  configStateId,
  contextParams,
  itemContent,
  itemLayout,
  metadata,
  screenId,
  screenStyles,
}) => (
  <div
    className={stylesAutoLayout.dlSavableComponentWrapper}
    style={{...screenStyles}}
  >
    <SavableComponentContainer
      autoLayoutStateId={autoLayoutStateId}
      config={config}
      configStateId={configStateId}
      contextParams={contextParams}
      content={itemContent}
      layout={itemLayout}
      metadata={metadata}
      screenId={screenId}
      screenStyles={screenStyles}
    />
  </div>
);

SingleScreenWrapper.displayName = 'SingleScreenWrapper';

SingleScreenWrapper.propTypes = {
  autoLayoutStateId: PropTypes.string.isRequired,
  config: PropTypes.objectOf(PropTypes.any).isRequired,
  configStateId: PropTypes.string.isRequired,
  contextParams: PropTypes.objectOf(PropTypes.any).isRequired,
  itemContent: PropTypes.instanceOf(ContentComponent).isRequired,
  itemLayout: PropTypes.instanceOf(LayoutComponent).isRequired,
  metadata: PropTypes.instanceOf(MetadataSchema).isRequired,
  screenId: PropTypes.string.isRequired,
  screenStyles: PropTypes.objectOf(PropTypes.any),
};

SingleScreenWrapper.defaultProps = {
  screenStyles: undefined,
};

export default SingleScreenWrapper;
